export default __webpack_public_path__ + "preview-sms.png";